import { Checkbox, Form, Input, Select } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { useUpdateProvider } from '../../utils/api.hook';
import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { FormInstance } from 'antd/lib';
import { FindProvider } from '../../utils/api-client';
import { ProviderTypeSelectorComponent } from '../../shared/provider-type-selector.component';
import { LineGroupIdInputComponent } from '../../shared/line-group-id-input.component';
import { PROVIDER_STATUS_OPTIONS } from '../../constants/provider-form.types';

export default function ProviderInfoComponent() {
  const { formRef, provider } = useOutletContext<{
    formRef: React.RefObject<FormInstance>;
    provider: FindProvider;
  }>();
  const { mutateAsync: updateProvider } = useUpdateProvider();

  useEffect(() => {
    formRef.current?.resetFields();
  }, [formRef, provider]);

  return (
    <Form
      ref={formRef}
      autoComplete="off"
      preserve={false}
      initialValues={provider}
      onFinish={(values) => {
        updateProvider(values);
      }}
    >
      <FormItem
        label="合作狀態"
        name="status"
        rules={[
          {
            required: true,
            message: '請選擇合作狀態',
          },
        ]}
      >
        <Select options={PROVIDER_STATUS_OPTIONS} />
      </FormItem>
      <FormItem
        name="id"
        label="ID"
        hidden
        rules={[
          {
            required: true,
            message: '請輸入ID',
          },
        ]}
      >
        <Input />
      </FormItem>
      <FormItem
        name="idNumber"
        label="編號"
        rules={[
          {
            required: true,
            message: '請輸入編號',
          },
        ]}
      >
        <Input />
      </FormItem>
      <FormItem
        name="name"
        label="名稱"
        rules={[
          {
            required: true,
            message: '請輸入名稱',
          },
        ]}
      >
        <Input />
      </FormItem>
      <FormItem
        name="nickname"
        label="簡稱"
        rules={[
          {
            required: true,
            message: '請輸入簡稱',
          },
        ]}
      >
        <Input />
      </FormItem>
      <ProviderTypeSelectorComponent />
      <LineGroupIdInputComponent />
      <FormItem
        name="needPosSticker"
        label="是否需要POS單貼紙"
        valuePropName="checked"
      >
        <Checkbox />
      </FormItem>
      <FormItem label="食品業者登錄字號" name="foodBusinessRegistrationNumber">
        <Input />
      </FormItem>
      <FormItem
        label="統一編號"
        name="taxId"
        rules={[
          {
            type: 'string',
            len: 8,
            message: '統一編號長度為 8',
          },
        ]}
      >
        <Input />
      </FormItem>
      <FormItem label="地址" name="address">
        <Input />
      </FormItem>
      <FormItem label="地址備註" name="addressComment">
        <Input />
      </FormItem>
    </Form>
  );
}
